import React from 'react';
import PropTypes from 'prop-types';
import { Box, SvgIcon } from '@mui/material';
import LeakRateExceedSvg from '../../../../../Icons/ic_epaLeakRateExceeded.svg?react';
import { determineLeakRateIcon } from '../../../Table/utils';

const LeakRateIcon = ({ epaAnnualizedLeakRate, assetTypeId }) => {
    const shouldShow = determineLeakRateIcon(epaAnnualizedLeakRate, assetTypeId);
    if (!shouldShow) return null;

    return (
        <Box
            component="span"
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
            width="100%"
        >
            <SvgIcon
                component={LeakRateExceedSvg}
                viewBox="0 0 20 18"
                sx={{ width: 20, height: 20 }}
                aria-label="Leak Rate Exceeded"
            />
        </Box>
    );
};

LeakRateIcon.propTypes = {
    epaAnnualizedLeakRate: PropTypes.number.isRequired,
    assetTypeId: PropTypes.number.isRequired,
};

export default LeakRateIcon;
